import { ThemeProvider } from '@mui/material/styles';

import theme from '~/theme';
import { AppRouter } from './router';

export const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppRouter />
    </ThemeProvider>
  );
};
